import { FC, ReactNode } from 'react'
import { StickyContainer as RSStickyContainer } from 'react-sticky'

interface StickyContainerProps {
  enabled?: boolean;
  children: ReactNode;
}

const StickyContainer: FC<StickyContainerProps> = ({
  enabled,
  children,
}) => enabled ? (
  <RSStickyContainer style={{ position: 'relative', boxSizing: 'border-box' }}>
    {children}
  </RSStickyContainer>
) : (
  <div style={{ position: 'relative', boxSizing: 'border-box' }}>
    {children}
  </div>
)

export default StickyContainer
